/**
 * AvatarPicker — the PROFILE_AVATARS catalog as a selectable grid (radio
 * semantics: one choice, keyboard reachable buttons, selected ring). Used by
 * the /welcome claim step and the /account settings page.
 */
import { PROFILE_AVATARS } from './avatarManifest.js';

export interface AvatarPickerProps {
  /** Selected catalog id ('' = none yet). */
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}

export function AvatarPicker({ value, onChange, disabled }: AvatarPickerProps) {
  return (
    <div
      className="avatar-picker"
      role="radiogroup"
      aria-label="Choose your avatar"
      data-testid="avatar-picker"
    >
      {PROFILE_AVATARS.map((a) => {
        const selected = value === a.id;
        return (
          <button
            key={a.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`avatar-option${selected ? ' avatar-option--selected' : ''}`}
            onClick={() => onChange(a.id)}
            disabled={disabled}
            title={a.label}
            data-testid={`avatar-option-${a.id}`}
          >
            <img className="avatar-option__img" src={a.src} alt={a.alt} />
            <span className="avatar-option__label">{a.label}</span>
          </button>
        );
      })}
    </div>
  );
}
